import classNames from 'classnames'
import { useRouteError } from 'react-router-dom'

import styles from './ErrorPage.module.css'

const ErrorPage = ({ extraMargin }: { extraMargin?: boolean }) => {
  const error = useRouteError()
  const isDev = process.env.NODE_ENV === 'development'
  if (isDev) {
    console.error('Router error: ' + error)
  }

  return (
    <div
      className={classNames(
        styles.errorPage,
        extraMargin ? styles.marginTopExtra : '',
      )}
    >
      <h1 className={styles.title}>Sorry</h1>
      <p className={styles.info}>
        We couldn&apos;t find the page you were looking for.
      </p>
    </div>
  )
}

export default ErrorPage
